import { CalculationModelType, ModelDefaultValues } from '../contracts';

export const modelDefaultValues: Map<CalculationModelType, ModelDefaultValues> = new Map([
    [CalculationModelType.ModelI, new ModelDefaultValues({
        verticalLongitudinalDispersivity: 0.1,
        horizontalLongitudinalDispersivity: 1,
        horizontalTransversalDispersivity: 0.01,
        horizontalVerticalDispersivity: 0.005
    })],
    [CalculationModelType.ModelII, new ModelDefaultValues({
        verticalLongitudinalDispersivity: 0.1,
        bulkHydraulicConductivity: 0.000000063,
        fractureSpacing: 5.0,
        horizontalLongitudinalDispersivity: 1,
        horizontalTransversalDispersivity: 0.01,
        horizontalVerticalDispersivity: 0.005
    })],
    [CalculationModelType.ModelIII, new ModelDefaultValues({
        verticalLongitudinalDispersivity: 0.1,
        verticalTransversalDispersivity: 0.01,
        horizontalLongitudinalDispersivity: 1,
        horizontalTransversalDispersivity: 0.01,
        horizontalVerticalDispersivity: 0.005
    })],
    [CalculationModelType.ModelIV, new ModelDefaultValues({
        horizontalLongitudinalDispersivity: 1,
        horizontalTransversalDispersivity: 0.01,
        horizontalVerticalDispersivity: 0.005
    })],
    [CalculationModelType.ModelV, new ModelDefaultValues({
        horizontalLongitudinalDispersivity: 1,
        horizontalTransversalDispersivity: 0.01,
        horizontalVerticalDispersivity: 0.005
    })]
]);
